<mat-form-field class="full-width">
  <input type="text" placeholder="Search..." matInput [formControl]="communityAutocomplete" [matAutocomplete]="auto">
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  <mat-option *ngFor="let community of filteredCommunities | async" [value]="community" (click)="communitySelected.emit(communityAutocomplete.value)">
    {{ community.name }} ({{ community.shortname }})
  </mat-option>
</mat-autocomplete>
